import { render } from "./BusinessEnquiryPage.vue?vue&type=template&id=4fa3fb68&scoped=true&ts=true"
import script from "./BusinessEnquiryPage.vue?vue&type=script&lang=ts"
export * from "./BusinessEnquiryPage.vue?vue&type=script&lang=ts"

import "./BusinessEnquiryPage.vue?vue&type=style&index=0&id=4fa3fb68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa3fb68"]])

export default __exports__